<template>
  <div class="seccion-invitacion">
    <div class="contenido-invitacion">

      <p class="bendicion" ref="bendicionRef">
        Con la bendición de Dios y gran alegría
      </p>

      <div class="nombres-padres" ref="nombresRef">
        <p>ABRAHAM RAMOS</p>
        <p>&</p>
        <p>RUBI RESENDEZ</p>
      </div>

      <div class="imagen-wrapper" ref="imagenRef">
        <img src="@/assets/fotoovalada.webp" alt="Quinceañera" class="imagen-ovalada" />
      </div>

      <p class="mensaje-invitacion" ref="mensajeRef">
        Tenemos el honor de invitarlos a celebrar los<br />
        XV años de nuestra hija
      </p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'InvitacionXV',
  setup() {
    const bendicionRef = ref(null);
    const nombresRef = ref(null);
    const imagenRef = ref(null);
    const mensajeRef = ref(null);

    const animateOnScroll = (element, animationFn) => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          animationFn();
          observer.unobserve(entry.target);
        }
      }, { threshold: 0.3 });
      observer.observe(element);
    };

    onMounted(() => {
      if (bendicionRef.value) {
        animateOnScroll(bendicionRef.value, () =>
          gsap.fromTo(bendicionRef.value, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }));
      }

      if (nombresRef.value) {
        animateOnScroll(nombresRef.value, () =>
          gsap.fromTo(nombresRef.value, { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 1.2, ease: 'back.out(1.7)' }));
      }

      if (imagenRef.value) {
        animateOnScroll(imagenRef.value, () =>
          gsap.fromTo(imagenRef.value, { opacity: 0, scale: 0.3 }, { opacity: 1, scale: 1, duration: 1.5, ease: 'elastic.out(1, 0.5)' }));
      }

      if (mensajeRef.value) {
        animateOnScroll(mensajeRef.value, () =>
          gsap.fromTo(mensajeRef.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1.3, ease: 'power3.out', delay: 0.2 }));
      }
    });

    return { bendicionRef, nombresRef, imagenRef, mensajeRef };
  }
};
</script>

<style scoped>
.seccion-invitacion {
  background: #fefefe;
  padding: 60px 20px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
}

.contenido-invitacion {
  max-width: 500px;
  margin: 0 auto;
}

.bendicion {
  font-family: 'FeelingPassionate', cursive;
  font-size: 20px;
  margin-bottom: 20px;
  color: #5c5c5c;
  opacity: 0;
}

.nombres-padres {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  color: #2b2b2b;
  line-height: 1.6;
  margin-bottom: 30px;
  opacity: 0;
}

.imagen-wrapper {
  width: 360px;
  height: 600px;
  margin: 0 auto 30px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  background: white;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  opacity: 0;
}

.imagen-ovalada {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mensaje-invitacion {
  font-size: 16px;
  line-height: 1.7;
  color: #4a4a4a;
  font-family: 'Poppins', sans-serif;
  opacity: 0;
}
</style>
